<template>
    <modal
        v-if="show"
        :form="form"
        confirm
        type="is-danger"
        size="is-xsmall"
        :title="titleModal"
        submit-text="Delete"
        @submit="handleSubmit"
        @closed="handleClosed"
    >
        Are you sure you want to delete this Toll-Free {{ item.title }}? This can not be undone.
    </modal>
</template>

<script>
import Form from 'core/Form';
import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    emits: ['closed'],

    data: () => ({
        form: new Form({}),
    }),

    computed: {
        titleModal() {
            return `Delete Toll-Free ${this.item.title}`;
        },

        show() {
            return this.showTollFreeDeleteModal;
        },

        item() {
            return this.showTollFreeDeleteItem;
        },

        ...mapState(stores.TollFreeStore, ['showTollFreeDeleteModal', 'showTollFreeDeleteItem']),
    },

    watch: {
        show(value) {
            if (value) {
                this.init();
            }
        },
    },

    methods: {
        init() {
            this.reset();
        },

        reset() {
            this.form.reset();
        },

        handleClosed() {
            this.$store.dispatch('handleShowTollFreeDeleteModal', {
                status: false,
                item: null,
            });
            this.$emit('closed');
        },

        async handleSubmit() {
            try {
                await this.$store.dispatch('deleteTollFreeProfile', {
                    form: this.form,
                    id: this.item.id,
                });
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'handleSubmit');
            } finally {
                this.handleClosed();
            }
        },
    },
};
</script>
